export default "__VITE_ASSET__211af175__"